<ng-dialog-header title="Vessel Event"></ng-dialog-header>
<mat-dialog-content>
  <ng-container *ngIf="!loading else loadingTemplate">
    <div class="py-3">
      <form [formGroup]="form">
        <div class="row">
          <div class="col-md-6 col">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label ngRequired>Dock</mat-label>
              <input matInput formControlName="dock"/>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Vessel</mat-label>
              <input matInput formControlName="vessel"/>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label ngRequired>Contract Load Date</mat-label>
              <input matInput formControlName="contractLoadDate"/>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Comments</mat-label>
              <input matInput formControlName="comments"/>
            </mat-form-field>
          </div>
          <div class="col-md-6 col">
            <div class="py-2">
              <strong class="text-muted">Created By:</strong>
              <div>{{ event?.requestedBy }}</div>
            </div>
            <div class="py-2 mt-3">
              <strong class="text-muted">Requested Date:</strong>
              <div>{{ event?.requestedDate | date:'MM/dd/yyyy hh:mm a' }}</div>
            </div>
            <div class="py-2 mt-3">
              <strong class="text-muted">Current Status:</strong>
              <div>{{ event?.status }}</div>
            </div>
            <mat-form-field appearance="outline" class="w-100 mt-3">
              <mat-label>Change Status</mat-label>
              <mat-select formControlName="status"></mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col"></div>
        </div>
      </form>
    </div>
    <div style="min-height: 200px;" class="flex-grow-1">
      <ns-grid class="h-100"
               [name]="gridConfigurations.gridName"
               [columns]="gridConfigurations.columns"
               [data]="event?.nominees || []"
               [loading]="loading"
               [gridOptions]="gridConfigurations.options"
               [config]="gridConfigurations.headerOptions">
      </ns-grid>
    </div>
  </ng-container>
</mat-dialog-content>
<ng-dialog-footer>
  <div dialog-actions class="d-flex justify-content-end w-100">
    <button mat-stroked-button color="warn" aria-label="close" mat-dialog-close>Close</button>
  </div>
</ng-dialog-footer>

<ng-template #loadingTemplate>
  <ns-skeleton class="h-100" [type]="skeleton"></ns-skeleton>
</ng-template>
